import { forwardRef, useId } from 'react';
import { Icon, Logo, PixIcon } from '@/components/foundations';
import { formatBRL } from '@/components/foundations/Amount';
import { BrowserFrame } from './BrowserFrame';
import { PaymentOption } from './PaymentOption';

export type CheckoutMethod = 'card' | 'pix';

export type CheckoutPreviewProps = {
  /** Nome da loja (rótulo acessível da pré-visualização). */
  storeName: string;
  description: string;
  /** Total; número vira BRL. */
  amount: number | string;
  /** Cor primária (`--ck`). */
  color: string;
  methods: Record<CheckoutMethod, boolean>;
  selected: CheckoutMethod;
  onSelect?: (method: CheckoutMethod) => void;
  url?: string;
  id?: string;
};

/** Pré-visualização ao vivo do checkout do painel, controlada só por props. */
export const CheckoutPreview = forwardRef<HTMLDivElement, CheckoutPreviewProps>(function CheckoutPreview(
  { storeName, description, amount, color, methods, selected, onSelect, url = 'checkout.lisboon.com/loja-exemplo', id },
  ref,
) {
  const logoId = `lg${useId().replace(/:/g, '')}`;
  return (
    <BrowserFrame url={url} accent={color} id={id} ref={ref} label={`Pré-visualização do checkout de ${storeName}`}>
      <div className="pay">
        <div className="brand"><Logo id={logoId} /></div>
        <h3>Pagamento</h3>
        <p className="sm" id="pdesc">{description}</p>
        <div className="total-box"><small>Total a pagar</small><strong>{typeof amount === 'number' ? formatBRL(amount) : amount}</strong></div>
        <p className="choose">Escolha a forma de pagamento</p>
        <PaymentOption value="card" icon={<Icon name="card" />} title="Cartão de crédito" description="Pague com cartões Visa, Mastercard, Elo e mais." selected={selected === 'card'} hidden={!methods.card} onSelect={() => onSelect?.('card')} />
        <PaymentOption value="pix" icon={<PixIcon />} title="Pix" description="Pague com Pix e confirme na hora." selected={selected === 'pix'} hidden={!methods.pix} onSelect={() => onSelect?.('pix')} />
        <button type="button" className="paybtn"><Icon name="lock" />Pagar agora</button>
        <p className="secure"><Icon name="shield" />Ambiente seguro protegido por Lisboon</p>
      </div>
    </BrowserFrame>
  );
});
